import { SVG, SVGProps } from './svg'

export function IconCaretUp(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M17.8 13.5a.7.7 0 0 1 0 1l-.3.3-.5.2H7c-.2 0-.4 0-.5-.2l-.3-.3a.7.7 0 0 1 0-1l5.3-5.3a.7.7 0 0 1 1 0l5.3 5.3Z" />
    </SVG>
  )
}
